import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import storeFunction from "../../utils/storeFunction";
import PlaceholderImage from "../../assets/placeholder-rectangle.png";

const BookingInfoImage = (props) => {
  return (
    <>
      {props.bookingInfoImage && props.bookingInfoImage !== "" && (
        <div
          className="overflow-hidden relative block w-full"
          style={{ height: "36rem" }}>
          <LazyLoadImage
            alt={props.propertyName}
            src={
              props.disableResize
                ? props.bookingInfoImage
                : storeFunction.resizeImage(props.bookingInfoImage, 600, 600)
            }
            placeholderSrc={PlaceholderImage}
            wrapperClassName="w-full h-full object-cover"
            className="w-full h-full absolute object-cover"
          />
        </div>
      )}
      {(!props.bookingInfoImage || props.bookingInfoImage === "") && (
        <div className="flex justify-center items-center flex-1 overflow-hidden bg-gray-300 h-2/5"></div>
      )}
    </>
  );
};

export default BookingInfoImage;
